import React from 'react';
import {buildGoogleStaticMapUrl} from "../../../helpers/google_map"

export default function EmailRoutingPathMap(props) {
    const { geolocations } = props;
    const mapUrl = buildGoogleStaticMapUrl(geolocations);
    
    return (
        <a href={mapUrl} className="text-decoration-none" target="_blank" rel="noreferrer">
            <figure className="mt-2">
                <figcaption className="figure-caption font-weight-bold mb-1">Click image to view full screen:</figcaption>
                <img src={mapUrl} className="figure-img img-fluid rounded" alt="Email Routing Path" />
            </figure>
        </a>
    );
  }
  